import { render, staticRenderFns } from "./service-locations-sms-email.vue?vue&type=template&id=6308e051&scoped=true&"
import script from "./service-locations-sms-email.vue?vue&type=script&lang=js&"
export * from "./service-locations-sms-email.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-sms-email.vue?vue&type=style&index=0&id=6308e051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308e051",
  null
  
)

export default component.exports